import React from 'react';
import ProfileImage from '../../../../components/profileImage';



const OverviewTab = ({ player, team }) => {
    return (
        <div className="space-y-6">
            {/* Contact Information */}
            <div className="bg-white rounded-lg shadow p-6">
                <h2 className="text-lg font-medium text-gray-900 mb-4">Contact Information</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-center">
                        <svg className="h-5 w-5 text-gray-400 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                        <span className="text-gray-900">{player.email}</span>
                    </div>
                    <div className="flex items-center">
                        <svg className="h-5 w-5 text-gray-400 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                        </svg>
                        <span className="text-gray-900">{player.phone || "Not provided"}</span>
                    </div>
                </div>
            </div>

            {/* Team Information */}
            {team && (
                <div className="border-t border-gray-200 px-6 py-5">
                <h2 className="text-lg font-medium text-gray-900 mb-4">
                  Team Information
                </h2>
  
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <ProfileImage
                      image={team.logo}
                      alt={team.name}
                      className="w-24 h-24 rounded-xl object-cover border-2 border-gray-100"
                    />
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Name</h3>
                    <p className="mt-1 text-gray-900">{team.name}</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">
                      Unique Name
                    </h3>
                    <p className="mt-1 text-gray-900">{team.uniqueName}</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Type</h3>
                    <p className="mt-1 text-gray-900">{team.type}</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Gender</h3>
                    <p className="mt-1 text-gray-900">{team.gender}</p>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-gray-500">Sport</h3>
                    <p className="mt-1 text-gray-900">{team.sport}</p>
                  </div>
                </div>
              </div>
            )}
        </div>
    );
};

export default OverviewTab; 